import React from "react";
import { FaShieldAlt, FaRocket, FaCheckCircle } from "react-icons/fa";

function RiskMitigation() {
  return (
    <>
      <div className="services-style-three-area overflow-hidden default-padding-top blurry-shape-left-bottom">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="service-style-three-items">
                <div className="heading">
                  <h4 className="sub-title">Our Services</h4>
                  <h2 className="title split-text-right split-text-in-right">
                    Why Smart Contract Audits Are Essential
                  </h2>
                </div>

                <div className="services-style-three-carousel default-padding-bottom fade-up-anim swiper">
                  <div className="swiper-wrapper">
                    {/* Risk Mitigation */}
                    <div
                      className="swiper-slide"
                      style={{ width: "438px", marginRight: "30px" }}
                    >
                      <div className="service-style-three-item">
                        <div className="top">
                          <div className="icon">
                            <FaShieldAlt size={40} />
                          </div>
                          <h4>Risk Mitigation</h4>
                          <p>
                            Smart contracts handle significant value in the DeFi
                            ecosystem, making security a top priority. Our audit
                            process rigorously tests for vulnerabilities,
                            helping mitigate financial and operational risks.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Performance */}
                    <div
                      className="swiper-slide"
                      style={{ width: "438px", marginRight: "30px" }}
                    >
                      <div className="service-style-three-item">
                        <div className="top">
                          <div className="icon">
                            <FaRocket size={40} />
                          </div>
                          <h4>Improved Performance</h4>
                          <p>
                            Beyond security, we assess your contract’s
                            performance and efficiency, offering optimization
                            recommendations that can enhance speed and reduce
                            gas fees.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Compliance */}
                    <div
                      className="swiper-slide"
                      style={{ width: "438px", marginRight: "30px" }}
                    >
                      <div className="service-style-three-item">
                        <div className="top">
                          <div className="icon">
                            <FaCheckCircle size={40} />
                          </div>
                          <h4>Compliance & Transparency</h4>
                          <p>
                            Our audits ensure that your smart contracts are
                            compliant with industry standards. By working with
                            Xeer Technology,
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RiskMitigation;
